import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { MatCard, MatCardContent } from '@angular/material/card';

import { NavService } from '@common/services';

import { MeetingsComponent } from '../../components/meetings/meetings.component';


/**
 * Top-level meetings route (`/projects/meetings`). Sets the page title
 * and wraps the shared MeetingsComponent in a mat-card. The list is
 * unscoped (no projectId) so it shows every meeting in the environment
 * with a Project column.
 */
@Component({
  templateUrl: './meetings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatCard,
    MatCardContent,
    MeetingsComponent,
  ],
})
export class MeetingsViewComponent implements OnInit {

  private readonly _navService = inject(NavService);

  public ngOnInit(): void {
    this._navService.setTitle('Meetings');
  }
}
